import { icon } from './lib/common'

const selectors = {
  '.o-hero .ctas a, .o-hero-mini .ctas a': 'link-cta',
  '.o-hero-mini .menu .title': 'plus',
  '.n-text a:not(.button)': 'link',
  '.n-introduction a:not(.button)': 'link',
  '.n-etudiant .links a': 'link',
  '.n-text-media .m-text a:not(.button)': 'link',
  '.n-text-columns .content a:not(.button)': 'link',
  '.menu-secondary a, .menu-tertiary a': 'link',
  '.block-formations-list .block-link .link-arrow': 'link-cta',
}

for (const [selector, iconName] of Object.entries(selectors)) {
  const elements = document.querySelectorAll(selector)
  if (elements.length > 0) {
    for (const element of elements) {
      element.innerHTML =
        '<span>' + element.innerHTML + icon(iconName) + '</span>'
    }
  }
}
